import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import useAuth from '../hooks/useAuth'

const AuthCallback = () => {
  const { login } = useAuth()
  const history = useHistory()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const accessToken = params.get('accessToken')
    const refreshToken = params.get('refreshToken')
    const error = params.get('error')
    const message = params.get('message')

    if (error) {
      toast.error(message)
      history.replace('/')
      return
    }

    if (accessToken && refreshToken) {
      login(accessToken, refreshToken)
      const payload = JSON.parse(atob(accessToken.split('.')[1]))
      const role = payload.rol
      history.replace(role === 'admin' ? '/admin-analysis' : '/client-analysis')
    }
  }, []) // eslint-disable-line

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      Cargando...
    </div>
  )
}

export default AuthCallback
